<template>
  <div class="information">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="广告费导入" name="first">
        <FeeImportAds></FeeImportAds>
      </el-tab-pane>
      <!-- --------------------------库存批次 ----------------------- -->
      <el-tab-pane label="COD回款导入" name="second">
        <FeeImportCOD></FeeImportCOD>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
// 库存编辑
import FeeImportAds from './FeeImportAds'
// 新增产品库存
import FeeImportCOD from './FeeImportCOD'
export default {
  name: 'FeeImport',
  components: {
    FeeImportAds,
    FeeImportCOD
  },
  data() {
    return {
      activeName: 'first'
    }
  }
}
</script>
